import React, { useEffect , useContext } from 'react';
import L from 'leaflet'
import "leaflet.vectorgrid"
import {Marker, Popup, useMap} from 'react-leaflet';
import { Context } from '../store/reducer';
import { Line } from "react-chartjs-2";


import m_rainfall_1 from '../assets/img/marker/weather/m_choui_1.png';
import m_rainfall_2 from '../assets/img/marker/weather/m_choui_2.png';
import m_rainfall_3_upper from '../assets/img/marker/weather/m_choui_3_joushou.png';
import m_rainfall_3_lower from '../assets/img/marker/weather/m_choui_3_kakou.png';
import m_rainfall_4_upper from '../assets/img/marker/weather/m_choui_4_joushou.png';
import m_rainfall_4_lower from '../assets/img/marker/weather/m_choui_4_kakou.png';
import m_rainfall_5_upper from '../assets/img/marker/weather/m_choui_5_joushou.png';
import m_rainfall_5_lower from '../assets/img/marker/weather/m_choui_5_kakou.png';
import m_rainfall_2_upper from "../assets/img/marker/weather/m_suii_2_joushou.png";
import m_rainfall_2_lower from "../assets/img/marker/weather/m_suii_2_kakou.png";
import hanrei_tooltip from '../assets/img/hanrei_tooltip.png';
import icon_info from '../assets/img/icon_info.png';
import m_rainfall_6_upper from "../assets/img/marker/weather/m_suii_6_joushou.png";
import m_rainfall_6_lower from "../assets/img/marker/weather/m_suii_6_kakou.png";

/**
 * 38: 河川管理情報システム 潮位日集計
 * @param options
 * @returns {null}
 * @constructor
 */
const Component = ({options}) => {

    const handleSpotData = (item) => {

        let ret = []

        ret.push(<dl className='dl-list is-modal-spot'><dt>データ種別</dt><dd>{item["station_type_label"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>事業所名</dt><dd>{item["office_name"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>データ所管</dt><dd>{item["department"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>水系名</dt><dd>{item["water_system_name"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>河川名</dt><dd>{item["river_name"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>観測所番号</dt><dd>{item["observatory_id"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>観測所名</dt><dd>{item["name"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>緯度</dt><dd>{item["lat"]}</dd></dl>)
        ret.push(<dl className='dl-list is-modal-spot'><dt>経度</dt><dd>{item["lng"]}</dd></dl>)

        return ret
    }

    const map = useMap()
    const { state } = useContext(Context);

    return Object.keys(state["vis_38"].data).map((key, index) => {
        
        const item = state["vis_38"].data[key];
        
        let labels = [];

        let choui_value1_list = [];
        let choui_value2_list = [];
        let choui_value3_list = [];
        let choui_value4_list = [];

        Object.keys(item.rain_list).map(key => {

            const rainData = item.rain_list[key];
            
            labels.push(rainData.datetime);
            
            // 実測潮位[TP.cm]
            choui_value1_list.push(rainData.value1);
            // 天文潮位[TP.cm]
            choui_value4_list.push(rainData.value2);
            
            // 注意潮位
            choui_value2_list.push(item.tide_fixed1);
            // 警戒潮位
            choui_value3_list.push(item.tide_fixed2);
        })

        // 現在のスライダーの値(実測潮位)
        const currentTenMinutesValue = choui_value1_list[state.timeIdx] ? choui_value1_list[state.timeIdx] : 0;
        const prevTenMinutesValue = choui_value1_list[state.timeIdx - 1] ? choui_value1_list[state.timeIdx - 1] : 0;



        /**
         * 判定対象の値が途中で存在しない場合に、存在する中で1番近い下位レベルのアイコンを表示する処理。
         * @param index
         * @returns {*}
         */
        const getProperIcon = (index) => {

            const iconList = [];
            iconList[0] = {upper: m_rainfall_3_upper, lower : m_rainfall_3_lower}; //平常は常に存在する。
            iconList[1] = item.tide_fixed1 != "" ? {upper: m_rainfall_4_upper, lower : m_rainfall_4_lower} : null; //水防団待機が存在するか。
            iconList[2] = item.tide_fixed2 != "" ? {upper: m_rainfall_5_upper, lower : m_rainfall_5_lower} : null; //はんらん注意が存在するか。

            // レベルを順に下げていき、アイコンが設定されているものを返す。
            for (let i = 2; i >= 0; i--) {

                // 上のレベルは無関係なのでスキップ
                if (i > index) {
                    continue;
                }

                if (iconList[i]) {
                    return iconList[i];
                }
            }
        }


        // グレー
        let icon = m_rainfall_2

        if (currentTenMinutesValue === "**"
          || currentTenMinutesValue === "--"
          || currentTenMinutesValue === "") {
            // 欠測: グレー
            icon = m_rainfall_2

        } else if (currentTenMinutesValue === "MM"
          || currentTenMinutesValue === "CC") {
            // 閉局・メンテナンス: バツ付きグレー
            icon = m_rainfall_1

        } else if (item.tide_fixed1 != "" && currentTenMinutesValue < item.tide_fixed1) {
            
            // 平常(注意潮位未満): 白
            const tmpIcon = getProperIcon(0);
            icon = (currentTenMinutesValue >= prevTenMinutesValue) ? tmpIcon.upper : tmpIcon.lower

        } else if (item.tide_fixed2 != "" && currentTenMinutesValue < item.tide_fixed2) {
            // 平常(警戒潮位未満): 黄
            const tmpIcon = getProperIcon(1);
            icon = (currentTenMinutesValue >= prevTenMinutesValue) ? tmpIcon.upper : tmpIcon.lower

        } else if (item.tide_fixed2 != "" && currentTenMinutesValue >= item.tide_fixed2) {
            // 平常(警戒潮位以上):赤
            const tmpIcon = getProperIcon(2);
            icon = (currentTenMinutesValue >= prevTenMinutesValue) ? tmpIcon.upper : tmpIcon.lower

        } else {

            // 判定すべき値が全てブランクの場合、平常とする
            const tmpIcon = getProperIcon(0);
            icon = (currentTenMinutesValue >= prevTenMinutesValue) ? tmpIcon.upper : tmpIcon.lower
        }

        // if (item["name"] === "呉(阿賀)港") {
        //     console.log("実測潮位", currentTenMinutesValue)
        //     console.log("10分前実測潮位", prevTenMinutesValue)
        //     console.log("注意潮位", item.tide_fixed1)
        //     console.log("警戒潮位", item.tide_fixed2)
        //     console.log(item.tide_fixed1)
        //     console.log("currentTenMinutesValue - item.tide_fixed1", (currentTenMinutesValue - item.tide_fixed1))
        //     console.log("currentTenMinutesValue < item.tide_fixed1", (currentTenMinutesValue < item.tide_fixed1))
        //     console.log("item[\"name\"]", item["name"])
        //     console.log("icon", icon)
        // }


        const iconUrl = new L.Icon({
            iconUrl: icon,
            iconRetinaUrl: icon,
            iconSize: [35, 35],
            iconAnchor: [17, 23],
            popupAnchor: [0, -50]
        });
        

        return (
          <>
              <Marker
                position={[item.lat, item.lng]}
                icon={iconUrl}
              >
                  <Popup autoPan={false} minHeight={400} maxHeight={800} minWidth={600} closeOnClick>
                      
                      <div className={"modal-detail"}>
                      
                      {
                          handleSpotData(item)
                      }

                      <div className="p-graph">
                          <div className="p-graph__main">
                              
                      <Line
                        height={400}
                        width={500}
                        data={{
                            "labels": labels,
                            "datasets": [
                                // 潮位
                                {
                                    yAxisID: 'y_choui',
                                    "label": "実測潮位[TP.cm]",
                                    "data": choui_value1_list,
                                    "borderColor": "blue",
                                    "backgroundColor": "blue"
                                },
                                {
                                    "myFixedData": true,
                                    yAxisID: 'y_choui',
                                    "label": "天文潮位[TP.cm]",
                                    "data": choui_value4_list,
                                    "borderColor": "black",
                                    "backgroundColor": "black"
                                },
                                {
                                    "myFixedData": true,
                                    yAxisID: 'y_choui',
                                    "label": "注意潮位[TP.cm]",
                                    "data": choui_value2_list,
                                    "borderColor": "orange",
                                    "backgroundColor": "orange"
                                },
                                {
                                    "myFixedData": true,
                                    yAxisID: 'y_choui',
                                    "label": "警戒潮位[TP.cm]",
                                    "data": choui_value3_list,
                                    "borderColor": "red",
                                    "backgroundColor": "red"
                                },
                            ]
                        }}
                        options={{
                            // responsive: true,
                            maintainAspectRatio: true,
                            elements: {
                                point: {
                                    radius : function(context){
                                        return context.dataIndex === state.timeIdx ? 8 : 0
                                    },
                                }
                            },
                            scales: {
                                x: {
                                    ticks: {
                                        maxTicksLimit: 24, // 表示する最大ラベル数
                                        autoSkip: true // 全てのラベルを表示する場合はfalseに設定
                                    }
                                },
                                y_choui: {
                                    type: 'linear',
                                    display: true,
                                    position: 'left',
                                    max: 500,
                                    min: -100,
                                    title: {
                                        display: true,
                                        text: "潮位 [TP.cm]"
                                    }
                                },
                            }
                        }}
                        id="chart-key"
                      />

                      </div>

                          <div className="p-graph__hanrei">
                              <div>
                                  <a href="" className="modal-link __ttl" onClick={e => {e.preventDefault(); return false;}} style={
                                      {
                                      '--hover-before-background': `url(${icon_info})`,
                                      '--hover-after-background': `url(${hanrei_tooltip})`
                                      }
                                  }>凡例について</a>
                              </div>

                              <div className="p-graph-hanrei">
                                  <ul className="p-graph-hanrei__list">
                                      <li><span className="pgh-item pgh-keikaichoui260"></span><span className="pgh-txt">実測潮位<span className="__sm">［TP.cm］</span></span></li>
                                      <li><span className="pgh-item pgh-keikaichoui210"></span><span className="pgh-txt">天文潮位<span className="__sm">［TP.cm］</span></span></li>
                                      <li><span className="pgh-item pgh-jissokuchoui"></span><span className="pgh-txt">注意潮位<span className="__sm">［TP.cm］{item.tide_fixed1 ? item.tide_fixed1+"cm" : ""}</span></span></li>
                                      <li><span className="pgh-item pgh-tenmonchoui"></span><span className="pgh-txt">警戒潮位<span className="__sm">［TP.cm］{item.tide_fixed2 ? item.tide_fixed2+"cm" : ""}</span></span></li>
                                  </ul>
                              </div>
                              
                          </div>
                      </div>
                      </div>
                  </Popup>
              </Marker>

          </>
        );
    })
}

export default Component
